import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
// import { Container, Row, Col } from 'react-bootstrap';

import Header from '../../components/Header';
import Footer from '../../components/Footer';

import imgTest from '../../assets/images/timeline/2008.png';

import './styles.css';

function Sustainability() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    })
  }, [])

  const sustainabilityEl = React.useRef<HTMLDivElement>(null);
  const scrollBack = () => {
    if (sustainabilityEl && sustainabilityEl.current) {
      sustainabilityEl.current.scrollTo({
        top: 0,
        left: sustainabilityEl.current.scrollLeft - 328,
        behavior: 'smooth'
      });
    }
  };

  const scrollFoward = () => {
    if (sustainabilityEl && sustainabilityEl.current) {
      sustainabilityEl.current.scrollTo({
        top: 0,
        left: sustainabilityEl.current.scrollLeft + 328,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div>
      <Header />
      <div className="background-sustainability">
        <div className="bg"></div>
        <div className="container">
          <div className="banner content">
            <h1>Sustainability</h1>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
            Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
            Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
              Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="content gap">
          <h1>Stories</h1>
        </div>
        <div className="sustainability-sustainability">
          <div className="sustainability-button">
            <button className="back" onClick={scrollBack}>	&lt;</button>
          </div>
          <div ref={sustainabilityEl} className="sustainability-block">
            <Link to="/stories">
              <div className="sustainability-card">
                <img src={imgTest} alt="Test" />
                <h5>Doação para Associação AMATERRA</h5>
                <p>Visando incentivar as ações que eles já fazem de Agricultura Orgânica Familiar, preservação de Nascentes e Educação Ambiental</p>
              </div>
            </Link>
            <Link to="/stories">
              <div className="sustainability-card">
                <img src={imgTest} alt="Test" />
                <h5>Orquestra XV de Novembro.</h5>
                <p>Doação de um instrumento musical para a Orquestra XV de Novembro.</p>
              </div>
            </Link>
            <Link to="/stories">
              <div className="sustainability-card">
                <img src={imgTest} alt="Test" />
                <h5>Doação de Cestas Básicas (COVID-19)</h5>
                <p>Doação de Cestas Básicas para o município de Poção, visando apoiar os moradores do entorno dos Projetos Ouro Branco 1 e 2 e demais moradores durante o enfrentamento...</p>
              </div>
            </Link>
            <Link to="/stories">
              <div className="sustainability-card">
                <img src={imgTest} alt="Test" />
                <h5>Doação para Associação AMATERRA</h5>
                <p>Visando incentivar as ações que eles já fazem de Agricultura Orgânica Familiar, preservação de Nascentes e Educação Ambiental</p>
              </div>
            </Link>
            <Link to="/stories">
              <div className="sustainability-card">
                <img src={imgTest} alt="Test" />
                <h5>Orquestra XV de Novembro.</h5>
                <p>Doação de um instrumento musical para a Orquestra XV de Novembro.</p>
              </div>
            </Link>
            <Link to="/stories">
              <div className="sustainability-card">
                <img src={imgTest} alt="Test" />
                <h5>Doação de Cestas Básicas (COVID-19)</h5>
                <p>Doação de Cestas Básicas para o município de Poção, visando apoiar os moradores do entorno dos Projetos Ouro Branco 1 e 2 e demais moradores durante o enfrentamento...</p>
              </div>
            </Link>
            <Link to="/stories">
              <div className="sustainability-card">
                <img src={imgTest} alt="Test" />
                <h5>Doação para Associação AMATERRA</h5>
                <p>Visando incentivar as ações que eles já fazem de Agricultura Orgânica Familiar, preservação de Nascentes e Educação Ambiental</p>
              </div>
            </Link>
          </div>
          <div className="sustainability-button">
            <button className="foward" onClick={scrollFoward}>	&gt;</button>
          </div>
        </div>

      </div>
      <Footer />
    </div>
  )
}

export default Sustainability;